"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePrepayOrderResponseSchema = exports.CreatePrepayOrderResponseSchema = exports.UpdatePrepayOrderBodySchema = exports.CreatePrepayOrderBodySchema = exports.ListFundTransactionsResponseSchema = exports.ListFundTransactionsQuerySchema = exports.FundTransactionResponseSchema = exports.CreateFundTransactionBodySchema = exports.CurrentFundQuerySchema = exports.CurrentFundResponseSchema = exports.FundMoneySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const orders_1 = require("./orders");
exports.FundMoneySchema = typebox_1.Type.Number({
    // Can be positive or negative (debit or credit)
    minimum: -10000000,
    // Though money should be a multiple of this, we don't control JS floating point view (e.g. 1 is not a mulitple of 0.01)
    // multipleOf: 0.01,
    // Sensible to have a max, but unclear what should be
    maximum: 10000000,
    title: "Money",
    description: "Monetary value (currency free, see Currency)",
    examples: [-0.1, 0, 1.23, 4.56],
});
exports.CurrentFundResponseSchema = (0, core_1.StrictObject)({
    amount: exports.FundMoneySchema,
});
exports.CurrentFundQuerySchema = (0, core_1.StrictObject)({
    to: typebox_1.Type.Optional(core_1.TimestampSchema),
});
exports.CreateFundTransactionBodySchema = (0, core_1.StrictObject)({
    amount: exports.FundMoneySchema,
    reason: core_1.DescriptionSchema,
});
exports.FundTransactionResponseSchema = (0, core_1.StrictObject)({
    amount: exports.FundMoneySchema,
    reason: core_1.DescriptionSchema,
    ...core_1.ModelMetaFields,
});
exports.ListFundTransactionsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
});
exports.ListFundTransactionsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.FundTransactionResponseSchema);
exports.CreatePrepayOrderBodySchema = (0, core_1.StrictObject)({
    processor: ruby_1.PaymentProcessorTypeSchema,
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    budgetPaid: core_1.MoneySchema,
    voucherCode: (0, core_1.OptionalNullable)(ruby_1.VoucherCodeSchema),
});
exports.UpdatePrepayOrderBodySchema = (0, core_1.StrictObject)({
    campaignId: (0, core_1.OptionalNullable)(core_1.IdSchema),
    budgetPaid: typebox_1.Type.Optional(core_1.MoneySchema),
    voucherCode: (0, core_1.OptionalNullable)(ruby_1.VoucherCodeSchema),
});
exports.CreatePrepayOrderResponseSchema = orders_1.OrderResponseSchema;
exports.UpdatePrepayOrderResponseSchema = orders_1.OrderResponseSchema;
